import { render } from "./ChatContainer.vue?vue&type=template&id=5214780f&scoped=true"
import script from "./ChatContainer.vue?vue&type=script&lang=js"
export * from "./ChatContainer.vue?vue&type=script&lang=js"

import "./ChatContainer.vue?vue&type=style&index=0&id=5214780f&lang=scss&scoped=true"
import "./ChatContainer.vue?vue&type=style&index=1&id=5214780f&lang=css"

import exportComponent from "C:\\Projects\\swing_vue_chat\\chat_front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5214780f"]])

export default __exports__